// @flow

import Service from "app/services/Service";

class UserVideoProgressService extends Service {
    static base = "user-video-progress";

    saveUserProgress(
        uid: string,
        start_time: number,
        stop_time: number
    ): Promise<*> {
        return this.http.post(
            "",
            this.toSearchParams({
                uid: uid,
                start_time: start_time,
                stop_time: stop_time
            })
        );
    }
}

export default new UserVideoProgressService();



// WEBPACK FOOTER //
// ./src/app/services/UserVideoProgressService.js